"use client";
import cn from "clsx";
import { HTMLAttributes, useEffect } from "react";
import React from "react";
import MenuButton from "./menuButton";
import ScreenButton from "./screenButton";

import ThemeButton from "./themeButton";
import LanguageChanger from "./languageChanger";

import { fetchHost } from "@/util/fetchutil";
import SignButton from "./signButton";
import { LayoutProps } from "@/components/layout/layoutType";
import { Debug } from "@/util/debug";
import MainTimer from "./mainTimer";
import { Flex } from "@radix-ui/themes";
import ReloadButton from "./reloadButton";
import { mobileHidden } from "../list/defaultType";

interface SectionProps extends HTMLAttributes<HTMLElement> {
  className?: string;
}

export default function Tool({
  props,
  params,
  cookies,
  user,
}: {
  props: SectionProps;
  params?: LayoutProps;
  cookies?: { menuPosition?: string; screenType?: string; themeType?: string; setMenuPosition?: Function; setScreenType?: Function };
  user: {
    user: any | undefined;
    accessToken: string | null;
    accessChange: boolean;
  };
}) {
  useEffect(() => {
    if (user.accessChange) {
      Debug("accessChange start");
      const option = {
        mode: "cors",
        method: "POST",
        headers: { "Content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          accessToken: user.accessToken,
        }),
      };
      fetchHost(
        "/api/sign/refresh",
        option,
        undefined,
        (data: any) => {
          //Debug(data);
        },
        (e: any) => {
          Debug(e);
        },
      );
    }
  }, [user.accessChange, user.accessToken]);
  return (
    <div className={cn(props.className, "absolute top-0 w-full z-1")}>
      <div className="mx-auto flex flex-row-reverse max-w-7xl z-30">
        <Flex className="flex-row-reverse z-40 pl-4 fixed">
          <SignButton className=" my-1 z-40 mr-4" user={user.user} params={params} />
          <ScreenButton className=" my-1 z-40" screenType={cookies?.screenType} />
          <MenuButton className={" my-1 z-40 " + mobileHidden} menuPosition={cookies?.menuPosition} />
          <ThemeButton className=" my-1 z-40" themeType={cookies?.themeType} />
          <ReloadButton className=" my-1 z-40" offline={params?.offline ?? false} />
          <LanguageChanger className="z-40" locale={params?.locale} />
          <MainTimer className="main-timer z-40" params={params} menuPosition={cookies?.menuPosition} />
        </Flex>
      </div>
    </div>
  );
}
